import { AccountabilityExpenseService } from "./AccountabilityExpenseService";

export type { IAccountabilityExpenseService } from "./IAccountabilityExpenseService";

export const accountabilityExpenseService = new AccountabilityExpenseService();
